export type GenericStatusErrorType = {
  status: number
  message: string
  data?: any,
}
export function GenericStatusError(params: GenericStatusErrorType): GenericStatusErrorType {
  return params;
}
